import { Routes } from '@angular/router';

export const routes: Routes = [];



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/user/user.routes.ts